// eslint-disable-next-line import/prefer-default-export
export enum SubscriptionReminderState {
  DUE_DATE_UPCOMING = 'due-date-upcoming',
  GRACE_PERIOD = 'grace-period',
  DUE_DATE_PASSED = 'due-date-passed',
  READ_ONLY = 'read-only',
  CONTACT_ADMIN = 'contact-admin'
}
